<template src="./CartPreview.html"/>
<style lang="scss" scoped src="./CartPreview.scss"/>
<script>

import {
  SfHeading,
  SfAccordion,
  SfCollectedProduct,
  SfProperty,
  SfPrice,
  SfCircleIcon,
  SfDivider,
  SfImage,
  SfInput,
  SfButton,
  SfIcon
} from '@storefront-ui/vue';
import icons from "@/utils/icons";
import Api from "@/api/Api";
import OrkPrice from "@/components/Ork/OrkPrice";

import UserAddress from "@/components/UserAddress";


export default {
  name: 'CartPreview',
  components: {
    OrkPrice,
    SfAccordion,
    UserAddress,
    SfHeading,
    SfDivider,
    SfCollectedProduct,
    SfProperty,
    SfPrice,
    SfCircleIcon,
    SfIcon,
    SfImage,
    SfInput,
    SfButton
  },
  props: {
    giftCard: {
      default: null
    },
    currentCart: {
      default: null
    },
    isPaymentRetry: {
      default: false
    }
  },
  data() {
    return {
      loading: {
        cart: null,
      },
      icons: icons,
      totalItems: 0,
      isLogin: true,
      coupon: null,
    }
  },
  computed: {
    giftCardComputed: {
      get() {
        return this.giftCard;
      },
      set() {

      }
    },
    currentCartComputed: {
      get() {
        return this.currentCart;
      },
    },
    customer: {
      get() {
        return this.$store.getters.getProfile
      }
    },
  },

  methods: {
    setCoupon() {
      if (this.coupon) {
        Api.cart.addCoupon(this.coupon).then((data) => {
          this.$store.dispatch('setCart', data);
          this.$store.dispatch('sendNotification', {
            type: 'info',
            message: this.$i18n.t('coupon.add'),
            icon: icons.info
          });
        })
            .catch((e) => {
              switch (e.status) {
                case 409:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.add'),
                    icon: icons.error
                  });
                  break;
                case 404:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('coupon.not'),
                    icon: icons.error
                  });
                  break;
                default:
                  this.$store.dispatch('sendNotification', {
                    type: 'danger',
                    message: this.$i18n.t('errors.server.access'),
                    icon: icons.error
                  });
                  break
              }

            })
            .finally();
      }
    },
    removePncCode() {
      this.giftCardComputed = null
      this.$emit("setGiftCard", null)
    },
    removeCoupon() {
      Api.cart.removeCoupon()
          .then((data) => {
            this.$store.dispatch('setCart', data);
          })
          .catch((e) => {
            switch (e.status) {
              case 409:
                this.$store.dispatch('sendNotification', {
                  type: 'danger',
                  message: this.$i18n.t('coupon code already used'),
                  icon: icons.error
                });
                break;
              case 404:
                this.$store.dispatch('sendNotification', {
                  type: 'danger',
                  message: this.$i18n.t('coupon code not exist'),
                  icon: icons.error
                });
                break;
              default:
                break
            }
          })
          .finally();

    },
  }
};
</script>

